export interface NavLink {
  label: string;
  anchor: string;
  hot?: boolean;
}

const navLinks: NavLink[] = [
  { label: "现场直击", anchor: "scene" },
  { label: "塌房档案", anchor: "archive" },
  { label: "崩塌全记录", anchor: "timeline" },
  { label: "口碑预警", anchor: "reputation" },
  { label: "快讯流", anchor: "feed" },
  { label: "常见问题", anchor: "faq" },
];

export default function Topbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[70px] md:px-6">
        {/* 品牌 */}
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-display text-lg font-black text-background-50">
            呱
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg font-black tracking-tight text-foreground-950 md:text-xl">
              呱呱黑料
            </span>
            <span className="mt-1 text-[11px] font-medium tracking-wide text-foreground-500">
              塌房现场 · 实锤全记录
            </span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((item) => (
            <a
              key={item.anchor}
              href={`#${item.anchor}`}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* 右侧操作 */}
        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <a
            href="#newsletter"
            className="hidden whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800 sm:inline-flex"
          >
            订阅实锤
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 lg:hidden"
          >
            <i className="ri-menu-3-line text-xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}